import React from 'react';
import PowerMilkPreorder from './PowerMilkPreorder';

function App() {
  return (
    <PowerMilkPreorder />
  );
}

export default App;